<template>
    <h1 class="focus:outline-none text-base md:text-lg lg:text-xl font-bold leading-tight text-gray-800 mb-4">
        <slot/>
    </h1>
</template>

<script>
export default {
    name: "Headline"
}
</script>

